import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { loading } from '@/decorators';

var MoreWrapperModal = function (_super) {
  __extends(MoreWrapperModal, _super);

  function MoreWrapperModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.loadingStatus = false;
    _this.columns = [];
    _this.dataList = [];
    return _this;
  }

  MoreWrapperModal.prototype.setColumns = function () {
    this.columns = [{
      title: this.t('包材编码'),
      dataIndex: 'package_code',
      filterEmpty: true
    }, {
      title: this.t('包材名称'),
      dataIndex: 'package_name',
      filterEmpty: true
    }, {
      title: this.t('预报数量'),
      dataIndex: 'package_num',
      filterEmpty: true
    }];
  };

  MoreWrapperModal.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        this.dataList = this.rowData.data || [];
        return [2];
      });
    });
  };

  MoreWrapperModal.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  MoreWrapperModal.prototype.handleVisibleChange = function () {
    if (this.visible) {
      this.setColumns();
      this.queryList();
    } else {
      this.dataList = [];
    }
  };

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], MoreWrapperModal.prototype, "visible", void 0);

  __decorate([Prop({})], MoreWrapperModal.prototype, "rowData", void 0);

  __decorate([loading('loadingStatus')], MoreWrapperModal.prototype, "queryList", null);

  __decorate([Watch('visible', {
    deep: true,
    immediate: true
  })], MoreWrapperModal.prototype, "handleVisibleChange", null);

  MoreWrapperModal = __decorate([Component], MoreWrapperModal);
  return MoreWrapperModal;
}(Vue);

export default MoreWrapperModal;